import React from 'react'

import Box from '@mui/material/Box'
import CssBaseline from '@mui/material/CssBaseline'
import Toolbar from '@mui/material/Toolbar'
import AppBar from '@mui/material/AppBar'

import StaticPageMenu from './StaticPageMenu'
import StaticFlash from './StaticFlash'

export default function StaticTopMenu() {

  return (
    <React.Fragment>
      <Box sx={
        { display: 'flex', position: 'relative', zIndex: 2}
      }>
        <CssBaseline />
        <AppBar position='relative'>
          <Toolbar>
            <StaticPageMenu />
            <StaticFlash />
          </Toolbar>
        </AppBar>
      </Box>
    </React.Fragment>
  )
}